
import Card from "components/card";
import { DataGrid } from "@mui/x-data-grid";
import WorkersDrawer from "./WorkersDrawer";
import React, { useState, useEffect } from "react";
import { getAllWorkers } from "../functions";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import WorkersDelete from "./WorkersDelete";
import { columns } from "../columns";

const WorkersTable = () => {

  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [mode, setMode] = useState("POST");
  const [data, setWorkersData] = useState(null)
  const [dataColumns, setDataColumns] = useState(null);
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchData = async () => {
      let workers = await getAllWorkers();
      setWorkersData(workers);
      let col = columns(setOpen,setMode,setOpenDelete,dispatch);
      setDataColumns(col);
    }
    fetchData();
    
  }, [open,openDelete,dispatch]);


  const handleClose = () => {
    setOpen(false);
  }

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <WorkersDelete openDelete={openDelete} setOpenDelete={setOpenDelete}/>
      <WorkersDrawer open={open} handleClose={handleClose} mode={mode} />
      <Card extra={"w-full h-full p-5"}>
        <div className="relative flex items-center justify-end">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            <button 
        onClick={()=>{setOpen(true); setMode("POST")}}
        className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20">
         Agregar Nuevo Trabajador
        </button>
          </div>
        </div>
        {data ?(
        <DataGrid
            className="dark:text-white mt-8 h-max w-full"
            rows={data || []}
            columns={dataColumns || []}
            autoPageSize
            rowsPerPageOptions={[5, 10, 20,50,100]}
            checkboxSelection
            disableSelectionOnClick
            getRowHeight={() => 'auto'}
          />
          ):(
            <div className="flex justify-center pt-56">
                 <CircularProgress color="primary" />
                  <Typography>Cargando datos...</Typography>
         
            </div>
          ) }

      </Card>
    </Box>
  );
};

export default WorkersTable;
